import { ObservableFromFetch } from "../ObservableFromFetch"

export interface OrderViewSecurity {
  CanSeeOrdersAnyUserHasPlacedRole: OrderSecurityException[]
  CanOnlySeeOrdersTheyHavePlacedRole: OrderSecurityException[]
  ImplementationID?: number
  ClientID?: number
  ModifiedBy?: string
  Link?: string
}

export interface OrderSecurityException {
  Title: string
  Description: string
  Level: number
  RoleOrderSecurityID: number
  ImplementationID: number
  ClientID: number
  RoleID: number
  Active: boolean
  ModifiedBy?: any
  ModifiedOn: string
}

export function GetRoleOrderSecurity(clientRoleID: number, link?: string) {
  const params = { ClientRoleID: clientRoleID }
  const requestBody: string = JSON.stringify(link ? { ...params, Link: link } : params)

  return ObservableFromFetch<OrderViewSecurity>("FFOrderRoleOrderSecurity/GetRoleOrderSecurity", requestBody)
}

export  function SetRoleOrderSecurity(data: OrderViewSecurity) {
  const requestBody = JSON.stringify(data)
  return ObservableFromFetch<string>("FFOrderRoleOrderSecurity/SetRoleOrderSecurityOfClient", requestBody)
}


